import { httpsCallable } from "firebase/functions";
import { Target, VectorQuery } from "../../models/Keyword";
import { SearchRepository } from "./SearchRepository";
import { functions } from "../../utils/firebase";
import { ModelName } from "../../models/ModelName";

export class FirebaseVectorSearchRepository extends SearchRepository {
    async find(query: string, model?: ModelName, count?: number): Promise<Target[]> {
        const vectorQuery: VectorQuery = { query, count, model };
        let result = await httpsCallable<VectorQuery, any>(functions, "vectorQuery")(vectorQuery);
        console.log(result);
        return (result.data as Target[]);
    }
}